import React, { Component } from 'react';
import { Button } from 'primereact/button';
import axios from 'axios'  
import { ProgressBar } from 'primereact/progressbar';
import Server from './Server.js'

class UpFile extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.FileUpload = this.FileUpload.bind(this);
    this.uploadRef = React.createRef();

    this.state = {
      uploadImage: props.uploadImage || "",
      label: props.label,
      buttonLabel: props.buttonLabel,
      ContainerClass: props.ContainerClass,
      className: props.className,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1)
    }
  }
  FileUpload(e) {
    e.preventDefault();

    const formData = new FormData();
    let name = e.target.name;
    formData.append('name', name);
    formData.append('PagePics', "1");
    formData.append('ExtraFile', "1");
    formData.append('typeOfFile', "1");
    if(!e.target.files[0]){
      alert("ارتباط با سرور برقرار نشد مجددا امتحان کنید")  
      return;

    }
    formData.append('myImage', e.target.files[0]);

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    this.setState({
      loading: 1
    })
    axios({url:`${this.state.url}uploadFile`, data:formData, method:'post', config})
      .then((response) => {
        this.setState({
          uploadImage: this.state.absoluteUrl + response.data.split("public")[1]

        })
        this.props.callback({uploadImage:this.state.absoluteUrl + response.data.split("public")[1]});
        this.setState({
          loading: 0
        })
        

      })
      .catch((error) => {
        this.setState({
          loading: 0
        })
        console.log(error);
      });
  }
  render() {
    return (
        <div className={this.props.className||"col-lg-8 col-12 mt-3"} style={{ display: 'flex',flexDirection:'column', justifyContent: 'space-between',maxHeight:300, background: '#fff', alignItems: 'center' }} >
            <div  style={{width:'100%',padding:8,borderRadius:8,display:'flex',flexDirection:'column',height:"100%"}}>
            <div>
            <div>
              <div className="title">{this.state.label}</div>
            </div>
            <div>
              <input className="d-none"  id="uploadRef" ref={this.uploadRef} autoComplete="off" onChange={this.FileUpload} type="file" name="myImage" />
              <Button label={this.state.buttonLabel} style={{ width: '100%' }} onClick={() => {
                this.uploadRef.current.click();
                return false;
              }} />
            </div>
            </div>
            <div>

            {(this.state.uploadName || this.state.uploadImage) &&
          <div className={this.props.className||"col-lg-8 col-12 mt-3"} style={{ background: '#fff' }}>
            <div className="row" style={{  padding: 10 }}>
              <div className="col-12">
                <img src={this.state.uploadImage} style={{ width: 150 }} />
              </div>
              <div className="col-7">
                <div className="small-title">
                  {this.state.uploadName}
                </div>
                <div className="small-title">
                  {this.state.uploadSize}
                </div>
              </div>
            </div>
            {this.state.uploadName &&
              <div className="mt-2 mb-2">
                <ProgressBar value={this.state.percentageValue} />
              </div>
            }
            
          </div>
        }
          </div>
            </div>
            
          </div>

        
        


    )
  }
}


export default UpFile;